<template>
    <el-container class="main-container file-download-page">
        <el-main class="data-container">

            <el-tabs v-model="radio1">
                <el-tab-pane label="CN Server" name="CN Server"></el-tab-pane>
                <el-tab-pane label="US Server" name="US Server"></el-tab-pane>
                <el-tab-pane label="XK Server" name="XK Server"></el-tab-pane>
            </el-tabs>

            <!-- 24 分栏-->
            <el-row :gutter="20"><!--调整行高-->


                <el-card shadow="hover" class="fixed-height-card" v-if="radio1 !== 'XK Server'">
                    <div class="card-content">
                        <!-- 上半部分 -->
                        <div class="top-section">
                            <h3>安全校验日志</h3>
                            <p>FordOSC_Error.log<br /><br /></p>
                        </div>
                        <el-divider content-position="right"><el-icon>
                                <StarFilled />
                            </el-icon></el-divider>
                        <!-- 下半部分 -->
                        <div class="bottom-section">
                            <el-button type="primary" class="full-width-button" :loading="btLoading"
                                :disabled="!canUseDevTools"
                                @click="handleDLSecurityLog('FordOSC_Error.log')">下载文件</el-button>
                        </div>
                    </div>
                </el-card>

                <el-card shadow="hover" class="fixed-height-card">
                    <div class="card-content">
                        <!-- 上半部分 -->
                        <div class="top-section">
                            <h3>更新在线GGP日期</h3>
                            <p>更新后务必使用设备进行验证!!!</p>
                        </div>
                        <el-divider content-position="right">
                            <el-icon>
                                <Sunrise />
                            </el-icon>
                        </el-divider>
                        <!-- 下半部分 -->
                        <div class="bottom-section">
                            <el-row :gutter="10" style="margin-bottom: 5px;">
                                <el-col :span="12">
                                    <el-button type="primary" class="full-width-button"
                                        :disabled="!canUseDevTools"
                                        @click="handleGetGGPDate('USAFORD')">福特</el-button>
                                </el-col>
                                <el-col :span="12">
                                    <el-button type="primary" class="full-width-button" plain
                                        :disabled="!canUseDevTools"
                                        @click="handleGetGGPDate('MAZDA')">马自达</el-button>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                </el-card>


                <el-card shadow="hover" class="fixed-height-card" v-loading="abUploadLoading" v-if="radio1 !== 'XK Server'">
                    <div class="top-section">
                        <div class="card-content">
                            <!-- 上半部分 -->
                            <div class="top-section">
                                <h3>
                                    上传AB数据
                                    <span style="color: red; margin-left: 5px; cursor: pointer;"
                                        @click="showAbTooltipAlert">⚠️注意</span>
                                </h3>
                                <p>
                                    请上传原厂 .ab 文件，勿修改原始下载内容
                                </p>
                            </div>
                            <el-divider content-position="right">
                                <el-icon>
                                    <UploadFilled />
                                </el-icon>
                            </el-divider>
                            <!-- 下半部分 -->
                            <div class="bottom-section">
                                <el-button type="primary" class="full-width-button" :disabled="!canUseDevTools"
                                    @click="triggerFordAbUpload">
                                    上传文件
                                    <el-upload ref="uploadFordAbRef"
                                        :action="uploadFordAbActionUrl"
                                        :show-file-list="false" :on-success="handleFordAbUploadSuccess"
                                        :on-error="handleFordAbUploadError" :before-upload="beforeFordAbUpload"
                                        :headers="uploadHeaders"></el-upload>
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-card>
                <el-card shadow="hover" class="fixed-height-card" v-loading="loading" v-if="radio1 !== 'XK Server'">
                    <div class="top-section">
                        <div class="card-content">
                            <!-- 上半部分 -->
                            <div class="top-section">
                                <h3>
                                    上传变速箱TRID数据
                                    <span style="color: red; margin-left: 5px; cursor: pointer;"
                                        @click="showTooltipAlert">⚠️注意</span>
                                </h3>
                                <p>请上传.txt或原厂.6F文件</p>
                            </div>
                            <el-divider content-position="right">
                                <el-icon>
                                    <Share />
                                </el-icon>
                            </el-divider>
                            <!-- 下半部分 -->


                            <div class="bottom-section">
                                <el-button type="primary" class="full-width-button" @click="triggerTRIDUpload">
                                    上传文件
                                    <!-- 上传配置TRID组件 -->
                                    <el-upload ref="uploadTRIDRef"
                                        action="https://diagapi.wwftool.top/api/v1/diag/UpTRIDFile"
                                        :show-file-list="false" :on-success="handleAvatarSuccess"
                                        :on-error="handleAvatarError" :before-upload="beforeTRIDUpload"
                                        :headers="uploadHeaders"></el-upload>
                                </el-button>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-row>

            <el-row :gutter="20"> <!--调整行高-->

                <el-card shadow="hover" class="fixed-height-card" v-if="radio1 !== 'XK Server'">
                    <div class="top-section">
                        <div class="card-content">
                            <!-- 上半部分 -->
                            <div class="top-section">
                                <h3>在线so版本控制</h3>
                                <p>先上传MyCar,后修改!<br></p>
                            </div>
                            <el-divider content-position="right">
                                <el-icon>
                                    <Ship />
                                </el-icon>
                            </el-divider>
                            <!-- 下半部分 -->
                            <div class="bottom-section">
                                <el-row :gutter="10" style="margin-bottom: 5px;">
                                    <el-col :span="12">
                                        <el-button size="small" type="primary" :disabled="!canUseDevTools"
                                            @click="handleGetSoVersion('USAFORD')">福特综合</el-button>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-button size="small" type="danger" :disabled="!canUseDevTools"
                                            @click="handleGetSoVersion('IMM_USAFORD')">福特防盗</el-button>

                                    </el-col>
                                </el-row>
                                <el-row :gutter="10" style="margin-bottom: 5px;">
                                    <el-col :span="12">
                                        <el-button size="small" type="primary" plain 
                                            :disabled="!canUseDevTools"
                                            @click="handleGetSoVersion('MAZDA')">马自达综合</el-button>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-button size="small" type="danger" plain
                                            :disabled="!canUseDevTools"
                                            @click="handleGetSoVersion('IMM_MAZDA')">马自达防盗</el-button>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10" style="margin-bottom: 5px;">
                                    <el-col :span="12">
                                        <el-button size="small" type="primary" plain
                                            :disabled="!canUseDevTools"
                                            @click="handleGetSoVersion('HD_FORDCARGO')">FORDCARGO</el-button>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </el-card>

                <el-card shadow="hover" class="fixed-height-card">
                    <div class="top-section">
                        <div class="card-content">
                            <!-- 上半部分 -->
                            <div class="top-section">
                                <h3>FORD最新发行版本</h3>
                                <p>提交发行流程后更新!!!<br><br></p>
                            </div>
                            <el-divider content-position="right">
                                <el-icon>
                                    <Lightning />
                                </el-icon>
                            </el-divider>
                            <!-- 下半部分 -->
                            <div class="bottom-section">
                                <el-button type="primary" class="full-width-button"
                                    @click="handleGetLatestVer">填写版本号</el-button>
                            </div>
                        </div>
                    </div>
                </el-card>

                <el-card shadow="hover" class="fixed-height-card" v-loading="loading">
                    <div class="top-section">
                        <div class="card-content">
                            <!-- 上半部分 -->
                            <div class="top-section">
                                <h3>上传在线功能配置</h3>
                                <p>先更新SVN,再生成app_online.cfg!!!</p>
                            </div>
                            <el-divider content-position="right">
                                <el-icon>
                                    <MostlyCloudy />
                                </el-icon>
                            </el-divider>
                            <!-- 下半部分 -->
                            <div class="bottom-section">
                                <el-row :gutter="10" style="margin-bottom: 5px;">
                                    <el-col :span="12">
                                        <el-button type="primary" class="full-width-button" @click="triggerCfgUpload">
                                            上传文件
                                            <!-- 上传配置文件组件 -->
                                            <el-upload ref="uploadCfgRef"
                                                :action="uploadActionUrl"
                                                :show-file-list="false" :on-success="handleAvatarSuccess"
                                                :on-error="handleAvatarError" :before-upload="beforeAvatarUpload"
                                                :headers="uploadHeaders"></el-upload>
                                        </el-button>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-button type="danger" class="full-width-button" :loading="btLoading"
                                            :disabled="!canUseDevTools" plain
                                            @click="handleDLSecurityLog('app_online.cfg')">下载文件</el-button>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </div>
                </el-card>

                <el-card shadow="hover" class="fixed-height-card dtc-update-card" v-loading="dtcZipLoading">
                    <div class="top-section">
                        <div class="card-content">
                            <div class="top-section">
                                <h3>在线故障码更新</h3>
                                <p>上传包含22种语言TXT的zip</p>
                            </div>
                            <el-divider content-position="right">
                                <el-icon>
                                    <UploadFilled />
                                </el-icon>
                            </el-divider>
                            <div class="bottom-section">
                                <el-button type="primary" class="full-width-button" :loading="dtcZipLoading"
                                    :disabled="!canUseDevTools || dtcZipLoading" @click="triggerDtcZipUpload">
                                    上传ZIP
                                    <el-upload ref="uploadDtcZipRef"
                                        :action="uploadDtcTextZipActionUrl"
                                        accept=".zip"
                                        :show-file-list="false" :on-success="handleDtcZipSuccess"
                                        :on-error="handleDtcZipError" :before-upload="beforeDtcZipUpload"
                                        :on-progress="handleDtcZipProgress"
                                        :headers="uploadHeaders"></el-upload>
                                </el-button>
                                <el-progress v-if="dtcZipLoading || dtcZipProgress > 0"
                                    :percentage="dtcZipProgress"
                                    :status="dtcZipProgressStatus || undefined"
                                    :stroke-width="8" />
                                <div v-if="dtcZipProgressText" class="upload-status-text">
                                    {{ dtcZipProgressText }}
                                </div>
                            </div>
                        </div>
                    </div>
                </el-card>
            </el-row>
        </el-main>
    </el-container>

    <el-dialog v-model="dialogFormVisible2" class="file-download-dialog" :title="(useDiagID == 'USAFORD') ? '修改福特在线GGP日期' : '修改马自达在线GGP日期'"
        width="500px">
        <el-form :model="NewGGPDate">
            <el-form-item label="当前正式:" :label-width="formLabelWidth">
                <el-input v-model="CurGGPDate" autocomplete="off" disabled />
            </el-form-item>
            <el-form-item label="当前测试:" :label-width="formLabelWidth">
                <el-input v-model="CurGGPTestDate" autocomplete="off" disabled />
            </el-form-item>
            <el-form-item label="修改:" :label-width="formLabelWidth">
                <el-input v-model="NewGGPDate" autocomplete="off" />
            </el-form-item>
            <el-form-item label="全量下发:" :label-width="formLabelWidth">
                <el-switch v-model="AllSnSwitch" active-text="是" inactive-text="否" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取消</el-button>
                <el-button type="primary" @click="handleGGPDate">提交</el-button>
            </span>
        </template>
    </el-dialog>


    <el-dialog v-model="dialogFormVisible" class="file-download-dialog" title="修改马自达账号密码" width="500px">
        <el-form :model="NewMacc">
            <el-form-item label="当前:" :label-width="formLabelWidth">
                <el-input v-model="CurMacc" autocomplete="off" disabled />
            </el-form-item>
            <el-form-item label="修改:" :label-width="formLabelWidth">
                <el-input v-model="NewMacc" autocomplete="off" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取消</el-button>
                <el-button type="primary" @click="handleMacc">提交</el-button>
            </span>
        </template>
    </el-dialog>

    <el-dialog v-model="dialogFormVisible8" class="file-download-dialog" title="FORD最新发行版本,格式:vXX.XX" width="500px">
        <el-form :model="NewLastVer">
            <el-form-item label="当前:" :label-width="formLabelWidth">
                <el-input v-model="CurLastVer" autocomplete="off" disabled />
            </el-form-item>
            <el-form-item label="修改:" :label-width="formLabelWidth">
                <el-input v-model="NewLastVer" autocomplete="off" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible8 = false">取消</el-button>
                <el-button type="primary" @click="handleLastVersion">提交</el-button>
            </span>
        </template>
    </el-dialog>

    <el-dialog v-model="dialogFormVisible3" class="file-download-dialog" title="在线so版本控制页面" width="80%" :close-on-click-modal="false"
        :fullscreen="true">
        <div class="page-container">
            <!-- 使用 el-row 和 el-col 进行三列布局 -->
            <el-row :gutter="20" type="flex" direction="vertical" justify="center">
                <!-- 参数管理区域 -->
                <el-col :span="10" type="flex" direction="vertical" justify="center">

                    <el-card style="margin-bottom: 10px;" v-loading="btLoading2">

                        <h3>参数管理</h3>
                        <el-tabs v-model="currentVersion" type="card" style="width: 100%; height: 100%;" tab-scrollable>
                            <el-tab-pane v-for="(version, index) in versions" :label="version.name"
                                :name="version.name">
                                <el-table :data="version.params" style="width: 100%; height: 180px;">
                                    <el-table-column label="参数名称" prop="key" min-width="45%"></el-table-column>
                                    <el-table-column label="参数值" prop="value" min-width="40%">
                                        <template #default="scope">
                                            <el-input v-model="scope.row.value" size="small">
                                                <template #append>
                                                    <!-- 提交修改后的内容 -->
                                                    <el-popconfirm :title="scope.row.key === 'DeleteOL'
                                                        ? '确认修改?(注意:该参数修改为TRUE时,删除所有序列号的so文件)'
                                                        : scope.row.key === 'AllSn'
                                                            ? '确认修改?(注意:AllSn为TRUE时,所有接头号都下发数据,控制的so需要加前缀如(AllSnlibOLUSAF...))'
                                                            : '确认修改?'" @confirm="EditParam(scope.row)">
                                                        <template #reference>
                                                            <el-button>
                                                                <el-icon>
                                                                    <Edit />
                                                                </el-icon>
                                                            </el-button>
                                                        </template>
                                                    </el-popconfirm>
                                                </template>
                                            </el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" min-width="15%">
                                        <template #default="{ row }">
                                            <el-button @click="removeParam(row)" size="small" type="danger"
                                                disabled>删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-button @click="dialogFormVisible5 = true" type="primary">添加参数</el-button>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>

                    <!-- 版本管理区域 -->
                    <el-card v-loading="btLoading2">
                        <h3>版本管理</h3>

                        <el-tabs v-model="currentVersion" type="card" style="width: 100%; height: 100%;" tab-scrollable>
                            <el-tab-pane v-for="(version, index) in versions" :label="version.name"
                                :name="version.name">
                                <el-table :data="version.keyValuePairs" style="width: 100%; height: 200px;">
                                    <!-- 调整“键”列宽度，设置最小宽度 -->
                                    <el-table-column label="so" prop="key" min-width="45%" />

                                    <!-- 调整“值”列宽度，设置最小宽度 -->
                                    <el-table-column label="版本" prop="value" min-width="40%">
                                        <template #default="scope">
                                            <el-input v-model="scope.row.value" size="small">

                                                <template #append>
                                                    <!-- 提交修改后的内容 -->

                                                    <el-popconfirm title="确认修改?" @confirm="EditParam2(scope.row)">
                                                        <template #reference>
                                                            <el-button>
                                                                <el-icon>
                                                                    <Edit />
                                                                </el-icon>
                                                            </el-button>
                                                        </template>
                                                    </el-popconfirm>

                                                </template>
                                            </el-input>

                                        </template>
                                    </el-table-column>

                                    <!-- 调整“操作”列宽度，设置最小宽度 -->
                                    <el-table-column label="操作" min-width="15%">
                                        <template #default="{ row }">

                                            <el-popconfirm title="确认删除?" @confirm="removeKeyValue(row)">
                                                <template #reference>
                                                    <el-button size="small" type="danger">删除</el-button>
                                                </template>
                                            </el-popconfirm>

                                        </template>
                                    </el-table-column>
                                </el-table>

                            </el-tab-pane>
                            <el-button @click="dialogFormVisible6 = true" type="primary">新增版本</el-button>
                            <el-button @click="dialogFormVisible7 = true" type="primary"
                                style="margin-left: 10px;">新增so名称</el-button>
                        </el-tabs>

                        <!-- 按钮放在底部 -->
                        <!-- <div style="margin-top: 20px;"> -->

                        <!-- </div> -->
                    </el-card>
                </el-col>

                <!-- 序列号列表区域 -->
                <el-col :span="10">
                    <el-card v-loading="btLoading2">
                        <h3>外发序列号</h3>
                        <el-tabs v-model="currentVersion" type="card" tab-scrollable>
                            <el-tab-pane v-for="(version, index) in versions" :key="version.name" :label="version.name"
                                :name="version.name">
                                <el-table :data="version.serialNumbers" style="width: 100%; height: 575px;">
                                    <el-table-column label="序列号" prop="serial" min-width="25%" />
                                    <el-table-column label="外发原因" prop="reason" min-width="55%" />
                                    <el-table-column label="操作" min-width="20%">
                                        <template #default="scope">
                                            <el-popconfirm title="确认删除?"
                                                @confirm="DeleteSoVersionSn(scope.$index, scope.row)">
                                                <template #reference>
                                                    <el-button size="small" type="danger">删除</el-button>
                                                </template>
                                            </el-popconfirm>

                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-button @click="dialogFormVisible4 = true" type="primary">添加序列号</el-button>
                            </el-tab-pane>
                        </el-tabs>
                    </el-card>
                </el-col>

            </el-row>
        </div>

        <el-dialog v-model="dialogFormVisible6" class="file-download-dialog" title="版本管理" width="500px" :close-on-click-modal="false">
            <el-form-item label="新增版本号:" :label-width="formLabelWidth">
                <el-input v-model="NewVersionValue" autocomplete="off" />
            </el-form-item>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible6 = false">取消</el-button>
                    <el-button type="primary" @click="addVersion">提交</el-button>
                </span>
            </template>
        </el-dialog>

        <el-dialog v-model="dialogFormVisible7" class="file-download-dialog" title="版本管理" width="500px" :close-on-click-modal="false">
            <el-form-item label="新增so名称:" :label-width="formLabelWidth">
                <el-input v-model="NewSoName" autocomplete="off" />
            </el-form-item>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible7 = false">取消</el-button>
                    <el-button type="primary" @click="addNewSoName()">提交</el-button>
                </span>
            </template>
        </el-dialog>


        <el-dialog v-model="dialogFormVisible5" class="file-download-dialog" title="添加全局参数" width="500px" :close-on-click-modal="false">
            <el-form :model="NewParm">
                <el-form-item label="参数名称:" :label-width="formLabelWidth">
                    <el-input v-model="NewParm.key" autocomplete="off" />
                </el-form-item>
                <el-form-item label="参数值:" :label-width="formLabelWidth">
                    <el-input v-model="NewParm.value" autocomplete="off" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible5 = false">取消</el-button>
                    <el-button type="primary" @click="addParam">提交</el-button>
                </span>
            </template>
        </el-dialog>

        <el-dialog v-model="dialogFormVisible4" class="file-download-dialog" title="添加so外发接头" width="500px" :close-on-click-modal="false">
            <el-form :model="NewSn">
                <el-form-item label="添加外发序列号:" :label-width="formLabelWidth">
                    <el-input v-model="NewSn.serial" autocomplete="off" maxlength="12" show-word-limit />
                </el-form-item>
                <el-form-item label="外发原因说明:" :label-width="formLabelWidth">
                    <el-input v-model="NewSn.reason" autocomplete="off" type="textarea" :rows="2" />
                </el-form-item>
            </el-form>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="dialogFormVisible4 = false">取消</el-button>
                    <el-button type="primary" @click="addSerial">提交</el-button>
                </span>
            </template>
        </el-dialog>

    </el-dialog>
</template>

<script>
import { ref,computed, reactive } from 'vue';
import { DownLoadFile, getSomeOne, setSomeOne, Post_setSomeOne } from '../api/users';
import { StarFilled, Sunrise, Ship, MostlyCloudy, Lightning, Edit, Share, UploadFilled } from '@element-plus/icons-vue';
import { ElMessage, ElNotification, ElMessageBox } from 'element-plus'
import { useStore } from 'vuex';
import { canUseDownloadMaintenanceTools } from '../utils/adminAccess.mjs';
export default {

    components: {
        StarFilled, Sunrise, Ship, MostlyCloudy, Lightning, Edit, Share, UploadFilled
    },

    setup() {
        const store = useStore();
        const uploadHeaders = ref({
            Authorization: 'Bearer ' + localStorage.getItem("authToken")  // 替换为你的 token
            //'Custom-Header': 'custom_value'           // 如果需要其他自定义请求头
        })
        const loading = ref(false);
        const abUploadLoading = ref(false);
        const dtcZipLoading = ref(false);
        const dtcZipProgress = ref(0);
        const dtcZipProgressStatus = ref('');
        const dtcZipProgressText = ref('');
        //const uploadRef = ref(null);
        const uploadFordAbRef = ref(null);
        const uploadTRIDRef = ref(null);
        const uploadCfgRef = ref(null);
        const uploadDtcZipRef = ref(null);

        const useDiagID = ref('');
        const radio1 = ref('CN Server');
        const CurGGPDate = ref('');
        const CurGGPTestDate = ref('');
        const NewGGPDate = ref('');
        const AllSnSwitch = ref(false);
        const CurLastVer = ref('');
        const NewLastVer = ref('');
        const CurMacc = ref('');
        const NewMacc = ref('');
        const NewVersionValue = ref('');
        const NewSoName = ref('');
        const DiagID = ref('');//区分车型
        const btLoading = ref(false);
        const btLoading2 = ref(false);
        const dialogFormVisible = ref(false);
        const dialogFormVisible2 = ref(false);
        const dialogFormVisible3 = ref(false);
        const currentUserRole = computed(() => String(store.state.userData?.job || '').trim());//区分测试还是开发
        const canUseDevTools = computed(() => canUseDownloadMaintenanceTools(store.state.userData));

        const dialogFormVisible4 = ref(false);//用于so版本控制中的提交外发序列号
        const dialogFormVisible5 = ref(false);//个性化参数设置

        const dialogFormVisible6 = ref(false);//版本管理 - 添加版本按钮
        const dialogFormVisible7 = ref(false);//版本管理 - 添加键值对按钮

        const dialogFormVisible8 = ref(false);//FORD最新发行版本 - 按钮
        //模拟数据/////////////////////////////////////////////////////
        const tooltipContent = `上传.txt 文件每行格式:
        1733376461769\\t1A0E04A2...<br>
        注意：\\t 表示制表符(Tab)，请不要输入字符 \\t。<br>
        原厂下载TRID数据链接: <a href="https://www.motorcraftservice.com/TransStrategy" target="_blank" rel="noopener noreferrer" style="color:#409EFF;">点击这里访问</a>
        `;
        const abTooltipContent = `注意：不要修改原始下载文件内容，避免空格、换行或编码变化导致数据异常。<br>
        文件名示例：1FDNF6CNXSDF61117.ab<br>
        AB文件下载链接: <a href="https://www.motorcraftservice.com/ASBUILT" target="_blank" rel="noopener noreferrer" style="color:#409EFF;">点击这里访问</a>
        `;

        const uploadActionUrl = computed(() => {
            return radio1.value === 'XK Server'
                ? 'https://diagapi.xk.wwftool.top/api/v1/diag/UploadOLCfgFile'
                : 'https://diagapi.wwftool.top/api/v1/diag/UploadOLCfgFile';
        });

        const uploadDtcTextZipActionUrl = computed(() => {
            if (radio1.value === 'CN Server') {
                return 'https://diagapi.wwftool.top/api/v1/diag/UploadDtcTextZip';
            }
            if (radio1.value === 'US Server') {
                return 'https://diagapi.us.wwftool.top/api/v1/diag/UploadDtcTextZip';
            }
            if (radio1.value === 'XK Server') {
                return 'https://diagapi.xk.wwftool.top/api/v1/diag/UploadDtcTextZip';
            }
            return 'https://diagapi.wwftool.top/api/v1/diag/UploadDtcTextZip';
        });

        const uploadFordAbActionUrl = computed(() => {
            if (radio1.value === 'CN Server') {
                return 'https://diagapi.wwftool.top/api/v1/diag/UploadFordABFile';
            }
            if (radio1.value === 'US Server') {
                return 'https://diagapi.us.wwftool.top/api/v1/diag/UploadFordABFile';
            }
            if (radio1.value === 'XK Server') {
                return 'https://diagapi.xk.wwftool.top/api/v1/diag/UploadFordABFile';
            }
            return 'https://diagapi.wwftool.top/api/v1/diag/UploadFordABFile';
        });

        const params = ref([]);

        const versions = ref([]);
        // 默认选中第一个版本
        const currentVersion = ref('');
        //const serialNumbers = ref([]);

        const NewSn = reactive({
            serial: '',
            reason: ''
        })
        const NewParm = reactive({
            key: '',
            value: '',
            valueori: ''
        })


        const addParam = () => {
            if (!NewParm.key || !NewParm.value) {
                ElMessage.error('请填写所有字段');
                return;
            }

            //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            const form = { key: NewParm.key, value: NewParm.value, "DiagID": DiagID.value, version: currentVersion.value };
            try {
                Post_setSomeOne("X431 Server", form, 'SoVersionEditParam').then(response => {

                    ElMessage.success('已同步到CN/US服务器中');
                    params.value.unshift(form);
                    dialogFormVisible5.value = false;
                })
                    .catch(error => {
                        ElMessage.error('设置失败！错误原因:' + error);
                    });
            } catch (error) {
                ElMessage.error('设置失败！错误原因:' + error);
            }

            NewParm.key = '';
            NewParm.value = '';
        };

        const removeParam = (param) => {
            //目前屏蔽删除，避免误操作，需要删除，直接在服务器后台修改
        };

        const addVersion = () => {
            if (!NewVersionValue) {
                ElMessage.error('版本号不能为空');
                return;
            }
            // 验证格式
            const versionStr = NewVersionValue.value;
            if (versionStr.length !== 6) {
                ElMessage.error('版本号长度必须为6个字符');
                return;
            }

            if (!versionStr.includes('V') || !versionStr.includes('.')) {
                ElMessage.error('版本号必须包含V和.');
                return;
            }


            //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            const form = { "NewVersion": NewVersionValue.value, "DiagID": DiagID.value };
            try {
                Post_setSomeOne("X431 Server", form, 'SoVersionAddVersion').then(response => {

                    ElMessage.success('已同步到CN/US服务器中');
                    versions.value.unshift(
                        {
                            name: NewVersionValue.value,
                            keyValuePairs: [],
                            params: response.data.params
                        });
                    console.log(versions.value);
                    dialogFormVisible6.value = false;
                })
                    .catch(error => {
                        ElMessage.error('设置失败！错误原因:' + error);
                    });
            } catch (error) {
                ElMessage.error('设置失败！错误原因:' + error);
            }
        };

        const addNewSoName = () => {
            if (!NewSoName) {
                ElMessage.error('so名称不能为空');
                return;
            }

            //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            const form = { key: NewSoName.value, version: currentVersion.value, DiagID: DiagID.value };
            /////////////////////////////////////////////////////////////////////////////////////
            try {
                Post_setSomeOne("X431 Server", form, 'SoVersion2EditParam').then(response => {

                    ElMessage.success('已同步到CN/US服务器中');
                    const version = versions.value.find((v) => v.name === currentVersion.value);
                    version.keyValuePairs.push({ key: NewSoName.value, value: response.data.value });

                    dialogFormVisible7.value = false;
                })
                    .catch(error => {
                        ElMessage.error('设置失败！错误原因1:' + error);
                    });
            } catch (error) {
                ElMessage.error('设置失败！错误原因2:' + error);
            }
        };

        const removeKeyValue = (keyValue) => {
            const form = { version: currentVersion.value, key: keyValue.key, "DiagID": DiagID.value };
            //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            try {
                Post_setSomeOne("X431 Server", form, 'SoVersionRemoveKeyValue').then(response => {

                    ElMessage.success('已同步到CN/US服务器中');
                    const version = versions.value.find((v) => v.name === currentVersion.value);
                    const index = version.keyValuePairs.indexOf(keyValue);
                    if (index !== -1) {
                        version.keyValuePairs.splice(index, 1);
                    }
                })
                    .catch(error => {
                        ElMessage.error('设置失败！错误原因:' + error);
                    });
            } catch (error) {
                ElMessage.error('设置失败！错误原因:' + error);
            }
        };

        const addSerial = async () => {
            // 判断是否填写了所有字段
            if (!NewSn.serial || !NewSn.reason) {
                ElMessage.error('请填写所有字段');
                return;
            }

            if (NewSn.serial.length != 12) {
                ElMessage.error('序列号长度不足12位');
                return;
            }
            dialogFormVisible4.value = false;
            //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            const form = { serial: NewSn.serial, reason: NewSn.reason, DiagID: DiagID.value, version: currentVersion.value };
            try {
                Post_setSomeOne("X431 Server", form, 'SoVersionAddSn').then(response => {

                    ElMessage.success('已同步到CN/US服务器中');
                    const currentVerObj = versions.value.find(v => v.name === currentVersion.value);
                    if (currentVerObj) {
                        currentVerObj.serialNumbers.unshift(form);
                    }
                })
                    .catch(error => {
                        ElMessage.error('设置失败！错误原因:' + error);
                    });
            } catch (error) {
                ElMessage.error('设置失败！错误原因:' + error);
            }

            NewSn.serial = '';
            NewSn.reason = '';
        };


        const EditParam = async (row) => {
            //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            const form = { key: row.key, value: row.value, "DiagID": DiagID.value, version: currentVersion.value };

            try {
                Post_setSomeOne("X431 Server", form, 'SoVersionEditParam').then(response => {
                    ElMessage.success('已同步到CN/US服务器中');
                })
                    .catch(error => {
                        ElMessage.error('设置失败！错误原因:' + error);
                    });
            } catch (error) {
                ElMessage.error('设置失败！错误原因:' + error);
            }
        };

        const EditParam2 = async (row) => {
            //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            const form = { key: row.key, value: row.value, version: currentVersion.value, DiagID: DiagID.value };

            try {
                Post_setSomeOne("X431 Server", form, 'SoVersion2EditParam').then(response => {
                    ElMessage.success('已同步到CN/US服务器中');
                })
                    .catch(error => {
                        ElMessage.error('设置失败！错误原因:' + error);
                    });
            } catch (error) {
                ElMessage.error('设置失败！错误原因:' + error);
            }
        };

        const DeleteSoVersionSn = async (index, row) => {
            //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
            const form = { serial: row.serial, 'DiagID': DiagID.value, version: currentVersion.value };

            try {
                Post_setSomeOne("X431 Server", form, 'DeleteSoVersionSn').then(response => {

                    ElMessage.success('已同步到CN/US服务器中');
                    const currentVerObj = versions.value.find(v => v.name === currentVersion.value);
                    if (!currentVerObj) {
                        ElMessage.warning('当前版本未找到，无法删除本地序列号');
                        return;
                    }
                    currentVerObj.serialNumbers.splice(index, 1);
                })
                    .catch(error => {
                        ElMessage.error('删除失败！错误原因:' + error);
                    });
            } catch (error) {
                ElMessage.error('删除失败！错误原因:' + error);
            }
        };

        ////////////////////////////////////////////////////////////////

        //相应函数
        const handleDLSecurityLog = async (fileName) => {
            btLoading.value = true;
            ElMessage({ type: 'success', message: '请求下载中...', })
            try {
                //const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                await DownLoadFile(radio1.value, fileName);

            } catch (error) {
                ElMessage({ type: 'error', message: '请求资源失败，请重试', })
            }
            btLoading.value = false;
        };

        const handleGetGGPDate = async (DiagType) => {
            try {
                dialogFormVisible2.value = true;//显示窗口
                useDiagID.value = DiagType;
                //const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                let response;
                if (DiagType == 'USAFORD') {
                    response = await getSomeOne("X431 Server", 'getGGPDate');
                }
                else if (DiagType == 'MAZDA') {
                    response = await getSomeOne("X431 Server", 'getGGPDateMazda');
                }
                CurGGPDate.value = response.data.GGPDate;
                CurGGPTestDate.value = response.data.GGPTestDate || response.data.GGPDate;
                NewGGPDate.value = response.data.GGPTestDate || response.data.GGPDate;
                AllSnSwitch.value = !!response.data.AllSn;
            } catch (error) {
                ElMessage({ type: 'warning', message: '获取数据失败，请重试' });
                dialogFormVisible2.value = false;
            }
        };

        const handleGGPDate = async () => {
            try {
                if (NewGGPDate.value.length !== 10) {
                    ElMessage({ type: 'error', message: 'GGP日期填充格式不正确', })
                    return;
                }

                //const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                dialogFormVisible2.value = false;
                if (useDiagID.value == 'USAFORD') {
                    await setSomeOne("X431 Server", NewGGPDate.value, 'setGGPDate', { allSn: AllSnSwitch.value });
                }
                else if (useDiagID.value == 'MAZDA') {
                    await setSomeOne("X431 Server", NewGGPDate.value, 'setGGPDateMazda');
                }

                ElMessage({ type: 'success', message: '设置GGP日期成功(同步国内海外双服务器)' });
            } catch (error) {
                ElMessage({ type: 'warning', message: '设置GGP日期失败，请重试' });
                dialogFormVisible2.value = false;
            }
        }

        const handleGetMacc = async () => {
            try {
                dialogFormVisible.value = true;//显示窗口

                //const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                const response = await getSomeOne("X431 Server", 'getMazdaAccount');
                CurMacc.value = response.data.Acc;
                NewMacc.value = response.data.Acc;
            } catch (error) {
                ElMessage({ type: 'warning', message: '获取账号失败，请重试' });
                dialogFormVisible.value = false;
            }
        };

        const handleGetLatestVer = async () => {
            try {
                dialogFormVisible8.value = true;//显示窗口

                //const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                const response = await getSomeOne("X431 Server", 'getfordlastversion');
                CurLastVer.value = response.data.version;
                NewLastVer.value = response.data.version;
            } catch (error) {
                ElMessage({ type: 'warning', message: '获取版本号失败，请重试' });
                dialogFormVisible8.value = false;
            }
        };

        const handleLastVersion = async () => {
            try {
                //const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                if (
                    NewLastVer.value.length !== 6 ||
                    NewLastVer.value[0] !== 'v' ||
                    NewLastVer.value[3] !== '.'
                ) {
                    ElMessage({
                        type: 'error',
                        message: '版本号格式不正确，应为 vXX.XX',
                    });
                    return;
                }

                dialogFormVisible8.value = false;
                await setSomeOne("X431 Server", NewLastVer.value, 'setfordlastversion');
                ElMessage({ type: 'success', message: '设置FORD最新版本成功(同步国内海外双服务器)' });
            } catch (error) {
                ElMessage({ type: 'warning', message: '设置FORD最新版本成功，请重试' });
                dialogFormVisible8.value = false;
            }
        }

        const handleMacc = async () => {
            try {
                //const useBaseURL = (radio1.value === 'CN Server') ? true : false;

                dialogFormVisible.value = false;
                await setSomeOne("X431 Server", NewMacc.value, 'setMazdaAccount');
                ElMessage({ type: 'success', message: '设置mazda账号密码成功(同步国内海外双服务器)' });
            } catch (error) {
                ElMessage({ type: 'warning', message: '设置mazda账号密码失败，请重试' });
                dialogFormVisible.value = false;
            }
        }



        const handleGetSoVersion = async (param) => {
            try {
                //const useBaseURL = (radio1.value === 'CN Server') ? true : false;
                btLoading2.value = true;
                dialogFormVisible3.value = true;//显示窗口
                //请求服务器获取最新数据并填充
                const response = await getSomeOne("X431 Server", 'getSoVersionInfo?DiagID=' + param);

                btLoading2.value = false;
                //serialNumbers.value = response.data.serialNumbers;//外发序列号列表
                versions.value = response.data.versions;//按版本区分 so列表 + 控制参数列表
                // params.value = response.data.params;//总控制参数列表

                if (versions.value.length > 0) {
                    currentVersion.value = versions.value[0].name;  // 选中第一个版本
                } else {
                    currentVersion.value = ''; // 为空时避免报错
                }
                DiagID.value = param;//通过界面按钮设置软件包ID



            } catch (error) {
                ElMessage({ type: 'warning', message: '失败，请重试' });
                dialogFormVisible3.value = false;
            }
        };

        const triggerTRIDUpload = async () => {
            uploadTRIDRef.value?.$el.querySelector('input').click();
        };

        const triggerFordAbUpload = async () => {
            uploadFordAbRef.value?.$el.querySelector('input').click();
        };

        const triggerCfgUpload = async () => {
            uploadCfgRef.value?.$el.querySelector('input').click();
        };

        const triggerDtcZipUpload = async () => {
            uploadDtcZipRef.value?.$el.querySelector('input').click();
        };

        //const handleNothing = async () => {
        //   uploadRef.value?.$el.querySelector('input').click();
        //};

        // 上传前检查文件类型和大小
        const beforeAvatarUpload = (rawFile) => {
            console.log('上传的文件名是:', rawFile.name)

            // 检查文件类型
            const isCfg = rawFile.name.toLowerCase().endsWith('.cfg')
            if (!isCfg) {
                ElMessage.error('配置文件格式必须为 Cfg 格式！')
                return false
            }
            loading.value = true;
            return true
        }
        const beforeTRIDUpload = (rawFile) => {
            console.log('上传的TRID文件名是:', rawFile.name)

            // 检查文件类型，允许 .6f 或 .txt
            const isValid = rawFile.name.toLowerCase().endsWith('.6f') || rawFile.name.toLowerCase().endsWith('.txt')

            if (!isValid) {
                ElMessage.error('配置文件格式必须为 .6F 或 .txt！')
                return false
            }
            loading.value = true

            return true
        }

        const beforeFordAbUpload = (rawFile) => {
            console.log('上传的AB文件名是:', rawFile.name)
            const isValid = /^[A-Za-z0-9]{17}\.ab$/i.test(rawFile.name)

            if (!isValid) {
                ElMessage.error('AB文件名必须为17位VIN.ab，例如 1FDNF6CNXSDF61117.ab')
                return false
            }
            abUploadLoading.value = true

            return true
        }

        const beforeDtcZipUpload = (rawFile) => {
            console.log('上传的故障码语言包是:', rawFile.name)
            const isZip = rawFile.name.toLowerCase().endsWith('.zip')
            if (!isZip) {
                ElMessage.error('在线故障码更新文件必须为 ZIP 格式！')
                return false
            }
            dtcZipLoading.value = true
            dtcZipProgress.value = 0
            dtcZipProgressStatus.value = ''
            dtcZipProgressText.value = '准备上传...'
            return true
        }

        const handleDtcZipProgress = (event) => {
            const percent = Math.min(100, Math.max(0, Math.round(event?.percent || 0)))
            dtcZipProgress.value = percent
            dtcZipProgressStatus.value = percent >= 100 ? 'success' : ''
            dtcZipProgressText.value = percent >= 100 ? '已上传，服务器处理中...' : `上传中 ${percent}%`
        }

        const handleAvatarError = (err, file, fileList) => {
            console.error('上传失败:', err);
            ElMessage.error('上传失败，请重试！' + err);
            loading.value = false;
        }

        const handleFordAbUploadError = (err) => {
            console.error('AB数据上传失败:', err);
            ElMessage.error('AB数据上传失败，请检查文件名和网络！');
            abUploadLoading.value = false;
        }

        const handleDtcZipError = (err) => {
            console.error('在线故障码更新失败:', err);
            ElMessage.error('在线故障码更新失败，请检查ZIP内容！');
            dtcZipLoading.value = false;
            dtcZipProgressStatus.value = 'exception';
            dtcZipProgressText.value = '上传失败';
        }

        // 处理上传成功的回调
        const handleAvatarSuccess = (response, uploadFile) => {
            ElMessage.success('文件上传成功!(同步国内海外服务器)');
            loading.value = false;
        }
        const handleFordAbUploadSuccess = (response) => {
            abUploadLoading.value = false;
            if (response?.success === false || response?.result === 'error') {
                ElMessage.error(response?.message || 'AB数据上传失败');
                return;
            }
            ElMessage.success('AB数据上传成功');
        }
        const handleDtcZipSuccess = (response) => {
            dtcZipLoading.value = false;
            dtcZipProgress.value = 100;
            dtcZipProgressStatus.value = 'success';
            if (response?.success === false || response?.result === 'error') {
                dtcZipProgressStatus.value = 'exception';
                dtcZipProgressText.value = response?.message || '处理失败';
                ElMessage.error(response?.message || '在线故障码更新失败');
                return;
            }
            dtcZipProgressText.value = '处理完成';
            ElMessage.success(`在线故障码更新成功，已生成 ${response?.binCount ?? 22} 个BIN文件`);
        }
        const showTooltipAlert = () => {
            ElMessageBox.alert(tooltipContent, '注意提示', {
                confirmButtonText: '确定',
                type: 'info',
                showClose: true,
                dangerouslyUseHTMLString: true, // 开启 HTML 解析
            })
                .then(() => {
                    console.log('用户确认提示')
                })
                .catch(() => {
                    console.log('用户关闭提示')
                })
        }
        const showAbTooltipAlert = () => {
            ElMessageBox.alert(abTooltipContent, 'AB数据上传注意事项', {
                confirmButtonText: '确定',
                type: 'info',
                showClose: true,
                dangerouslyUseHTMLString: true,
            })
                .then(() => {
                    console.log('用户确认AB提示')
                })
                .catch(() => {
                    console.log('用户关闭AB提示')
                })
        }

        return {
            radio1, btLoading, dialogFormVisible, dialogFormVisible2, dialogFormVisible3, dialogFormVisible4, dialogFormVisible5, dialogFormVisible6, dialogFormVisible7, CurGGPDate, CurGGPTestDate, NewGGPDate, AllSnSwitch, CurMacc, NewMacc,
            handleDLSecurityLog, triggerTRIDUpload, triggerCfgUpload, handleGetGGPDate, handleGGPDate, handleGetMacc, handleMacc, handleGetSoVersion,
            params, versions, addParam, removeParam, addVersion, addNewSoName, NewSoName, removeKeyValue, addSerial, DeleteSoVersionSn, EditParam, EditParam2, currentVersion,
            NewSn, NewParm, NewVersionValue, DiagID, btLoading2, currentUserRole, canUseDevTools, useDiagID, loading, abUploadLoading,
            dialogFormVisible8, handleGetLatestVer, handleLastVersion, CurLastVer, NewLastVer, uploadHeaders, beforeAvatarUpload, handleAvatarError, handleAvatarSuccess, beforeTRIDUpload, tooltipContent,
            showTooltipAlert, showAbTooltipAlert, uploadCfgRef, uploadTRIDRef, uploadFordAbRef, uploadDtcZipRef, uploadActionUrl, uploadDtcTextZipActionUrl, uploadFordAbActionUrl,
            triggerFordAbUpload, beforeFordAbUpload, handleFordAbUploadSuccess, handleFordAbUploadError,
            triggerDtcZipUpload, beforeDtcZipUpload, handleDtcZipProgress, handleDtcZipSuccess, handleDtcZipError,
            dtcZipLoading, dtcZipProgress, dtcZipProgressStatus, dtcZipProgressText,
        };
    },
};
</script>

<style scoped>
.el-row {
    /* 调整行与行之间的间隔 */
    margin-bottom: 30px;
}

/* 卡片容器设置 */
.fixed-height-card {
    margin: 10px;
    height: 233px;
    width: 220px;
    /* 根据实际需求调整 */
    /* display: flex; */
    /* flex-direction: column; */
}

/* 内容区域填充 */
.card-content {
    /* display: flex; */
    /* flex-direction: column; */
    /* flex: 1; */
    padding: 0px;
    /* 控制卡片内部的内边距 */
    margin: 0px;
    /* 控制 card-content 和卡片边缘之间的外边距 */
}

/* 上半部分样式 */
.dtc-update-card {
    height: 233px;
}

.top-section {
    flex: 1;
}



.full-width-button {
    width: 100%;
    /* 使按钮的宽度占满整个容器 */
    height: 50px;
    /* 可选: 设置按钮的高度 */
}

.top-section>h3:nth-child(1) {
    margin-top: 0px;
}

.upload-status-text {
    margin-top: 6px;
    font-size: 12px;
    color: #606266;
    text-align: center;
}

:global(html.dark .file-download-page .el-button--primary),
:global(html.dark .file-download-dialog .el-button--primary) {
    color: var(--wf-status-info-text) !important;
    border-color: rgba(96, 165, 250, 0.46) !important;
    background: var(--wf-status-info-bg) !important;
    box-shadow: none !important;
}

:global(html.dark .file-download-page .el-button--primary:not(.is-disabled):hover),
:global(html.dark .file-download-page .el-button--primary:not(.is-disabled):focus),
:global(html.dark .file-download-dialog .el-button--primary:not(.is-disabled):hover),
:global(html.dark .file-download-dialog .el-button--primary:not(.is-disabled):focus) {
    color: #dbeafe !important;
    border-color: rgba(96, 165, 250, 0.7) !important;
    background: rgba(59, 130, 246, 0.24) !important;
}

:global(html.dark .file-download-page .el-button--danger),
:global(html.dark .file-download-dialog .el-button--danger) {
    color: var(--wf-status-danger-text) !important;
    border-color: rgba(248, 113, 113, 0.42) !important;
    background: var(--wf-status-danger-bg) !important;
    box-shadow: none !important;
}

:global(html.dark .file-download-page .el-button--danger:not(.is-disabled):hover),
:global(html.dark .file-download-page .el-button--danger:not(.is-disabled):focus),
:global(html.dark .file-download-dialog .el-button--danger:not(.is-disabled):hover),
:global(html.dark .file-download-dialog .el-button--danger:not(.is-disabled):focus) {
    color: #fee2e2 !important;
    border-color: rgba(248, 113, 113, 0.68) !important;
    background: rgba(239, 68, 68, 0.24) !important;
}

:global(html.dark .file-download-dialog .el-button:not(.el-button--primary):not(.el-button--danger)) {
    color: var(--wf-text-regular) !important;
    border-color: var(--wf-control-border) !important;
    background: var(--wf-surface-soft) !important;
    box-shadow: none !important;
}

:global(html.dark .file-download-dialog .el-button:not(.el-button--primary):not(.el-button--danger):not(.is-disabled):hover),
:global(html.dark .file-download-dialog .el-button:not(.el-button--primary):not(.el-button--danger):not(.is-disabled):focus) {
    color: var(--wf-text-primary) !important;
    border-color: #64748b !important;
    background: var(--wf-hover-bg) !important;
}

:global(html.dark .file-download-page .el-button.is-disabled),
:global(html.dark .file-download-dialog .el-button.is-disabled) {
    opacity: 0.58;
    box-shadow: none !important;
}


.page-container {
    padding: 20px;
}

el-card {
    margin-bottom: 20px;
}
</style>
